import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAllGroups({ payload }) {
  try {
    yield put(actions.groupLoading(true));
    const result = yield call(api.getAllGroups, payload);
    yield put(actions.getAllGroupsSuccess(result.data));
  } catch (error) {
    toast.error(error);
    yield put(actions.getAllGroupsFail());
  } finally {
    yield put(actions.groupLoading(false));
  }
}

export default function* StudentGroupSaga() {
  yield takeLatest(Types.GET_GROUPS_STUDENT_REQUEST, getAllGroups);
}
